import adminViewCoachmarks1 from "../common/icons/webicons/adminViewCoachmarks1.svg";
import adminViewCoachmarks2 from "../common/icons/webicons/adminViewCoachmarks2.svg";
import adminViewCoachmarks3 from "../common/icons/webicons/adminViewCoachmarks3.svg";
import adminViewCoachmarks4 from "../common/icons/webicons/adminViewCoachmarks4.svg";
import adminViewCoachmarks5 from "../common/icons/webicons/adminViewCoachmarks5.svg";
import adminViewCoachmarks6 from "../common/icons/webicons/adminViewCoachmarks6.svg";
import adminViewCoachmarks7 from "../common/icons/webicons/adminViewCoachmarks7.svg";
import adminViewCoachmarks8 from "../common/icons/webicons/adminViewCoachmarks8.svg";
import teamViewCoachmarks1 from "../common/icons/webicons/teamViewCoachmarks1.svg";
import teamViewCoachmarks2 from "../common/icons/webicons/teamViewCoachmarks2.svg";
import teamViewCoachmarks3 from "../common/icons/webicons/teamViewCoachmarks3.svg";
import inviteTeamCoachmarks1 from "../common/icons/webicons/inviteTeamCoachmarks1.svg";
import adminWelcomeCoachmark from "../common/icons/webicons/admin_welcome_coachmark.svg";

import adminPendingRequests from "../common/icons/webicons/admin_pending_requests.svg";
import adminAvailableIndicator from "../common/icons/webicons/admin_available_indicator.svg";
import adminUnavailableIndicator from "../common/icons/webicons/admin_unavailable_indicator.svg";
import adminApproveReject from "../common/icons/webicons/admin_approve_reject.svg";

import teamRequestLicense from "../common/icons/webicons/team_request_license.svg";
import teamRequestStatus from "../common/icons/webicons/team_request_status.svg";
import teamRejectReason from "../common/icons/webicons/team_reject_reason.svg";
import teamMembers from "../common/icons/webicons/team_members.svg";
import teamLeaveTeam from "../common/icons/webicons/team_leave_team.svg";

import adminLicenseRequests from "../common/icons/webicons/admin_license_requests.svg";
import manageLicenses from "../common/icons/webicons/manage_licenses.svg";
import sensorToolInfo from "../common/icons/webicons/sensor_tool_info.svg";
import activeExpiredLicenses from "../common/icons/webicons/active_expired_licenses.svg";
import renewLicenses from "../common/icons/webicons/renew_licenses.svg";
import assignedMembers from "../common/icons/webicons/assigned_members.svg";
import i18next from "../app/i18n";
export const SUBSCRIPTION_PRODUCT_MAPPING = {
  FCA: [
    "14831503-4AE8-41CF-924F-12627CEE49E0",
    "Fluke Connect™ Assets",
    "Assets"
  ],
  FCA_ENTERPRISE: [
    "A9DAAF19-2BDC-4CD7-B6F7-98627149988E",
    "Fluke Connect™ Assets - Enterprise",
    "Assets"
  ],
  FCA_OTHER: [
    "2E9A769B-0D87-4C93-9326-CE1DC87516B2",
    "Fluke Connect™ Assets",
    "Assets"
  ],
  FCA_10PACK: [
    "7AE2C906-FF65-4341-9731-ED6A045AF0E9",
    "Fluke Connect™ Assets - 10 Pack",
    "Assets"
  ],
  FCA_ADITIONAL: [
    "E4FC6FB9-C438-4588-9CA3-B6E64BDF06D5",
    "Fluke Connect™ Assets - Aditional",
    "Assets"
  ],
  FCA_5PACK: [
    "C63FA8B8-AD85-40D5-B39C-4D51D0AD0813",
    "Fluke Connect™ Assets - 5 Pack",
    "Assets"
  ],

  FCA_ORIGINAL: [
    "16ECE06B-06A9-4D16-AD56-BDBE23587911",
    "Fluke Connect™ Assets - Original User",
    "Free"
  ],

  FCCM: [
    "4381d1b6-13cf-4bc7-88d5-b775cefd127c",
    "Fluke Connect™ Condition Monitoring",
    "FCCM"
  ],
  FCCM_ELECTRICAL: [
    "355773a7-edcf-4887-a79e-731c0e179ad1",
    "Fluke Connect™ Condition Monitoring – Electrical",
    "Electrical"
  ],
  FCCM_POWER: [
    "9a0a6b89-8fb1-4351-b633-c4f703fc2e56",
    "Fluke Connect™ Condition Monitoring - Power",
    "Power"
  ],
  FCCM_POWER_LOGGER: [
    "185ca536-80e5-477f-af64-4a8da05074f7",
    "Fluke Connect™ Condition Monitoring – Power Logger",
    "Power Logger"
  ],
  FCCM_THERMAL: [
    "99341615-91e6-4e15-826a-7a7047a7fa82",
    "Fluke Connect™ Condition Monitoring - Thermal Imaging",
    "Thermal"
  ],
  FCCM_VIBRATION: [
    "20ed36da-fc0e-4a66-9fd2-c84870f0ff58",
    "Fluke Connect™ Condition Monitoring - Vibration",
    "Vibration"
  ],
  FCCM_VIBRATION_OTHER: [
    "d5ba3c32-aade-4d9b-b066-35b1692ce4fa",
    "Fluke Connect™ Condition Monitoring - Vibration",
    "Vibration"
  ],

  FCA_FREE: [
    "04A8D2E4-48A5-48B4-9213-4B48BF185179",
    "Fluke Connect™ Assets Free Trial",
    "Free"
  ],
  FCA_FREE_30_DAYS: [
    "4E9D5F64-8997-4E12-BCAA-69FBB4294C71",
    "Fluke Connect™ Assets Free Trial (30 day)",
    "Free"
  ],
  FCM: [
    "358603F4-DC47-4C76-AC30-42B3EFA883CB",
    "Fluke Connect™ Measurements",
    "Measurements"
  ]
};

export const SUBSCRIPTION_PRODUCT_ID = [
  "14831503-4AE8-41CF-924F-12627CEE49E0",
  "A9DAAF19-2BDC-4CD7-B6F7-98627149988E",
  "2E9A769B-0D87-4C93-9326-CE1DC87516B2",
  "7AE2C906-FF65-4341-9731-ED6A045AF0E9",
  "C63FA8B8-AD85-40D5-B39C-4D51D0AD0813",
  "16ECE06B-06A9-4D16-AD56-BDBE23587911",
  "4381d1b6-13cf-4bc7-88d5-b775cefd127c",
  "355773a7-edcf-4887-a79e-731c0e179ad1",
  "9a0a6b89-8fb1-4351-b633-c4f703fc2e56",
  "185ca536-80e5-477f-af64-4a8da05074f7",
  "99341615-91e6-4e15-826a-7a7047a7fa82",
  "20ed36da-fc0e-4a66-9fd2-c84870f0ff58",
  "d5ba3c32-aade-4d9b-b066-35b1692ce4fa",
  "04A8D2E4-48A5-48B4-9213-4B48BF185179",
  "4E9D5F64-8997-4E12-BCAA-69FBB4294C71",
  "358603F4-DC47-4C76-AC30-42B3EFA883CB"
];

export const FLUKE_GLOBAL = {
  PENDING: {
    objectStatusId: "4a35d9c6-0532-11e3-b325-4eb9b35797f1"
  }
};
export const BLANK_STRING = "";
export const INVITE_USER_PLACEHOLDER =
  "You are invited to join Fluke Connect team hosted by Fluke Admin";
export const USER_CONSTANT = "user";
export const TEAM_ALT = "team";
export const EMAIL_CONSTANT = "email";
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MOBILE_REGEX = /^[+]?[()]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,11}$/im;
export const COMMA_UNICODE = 188;
export const ENTER_UNICODE = 13;
export const NOT_VALID_EMAIL_CONSTANT = "not-valid-email";
export const BACKSPACE_CONSTANT = "Backspace";
export const INPUT_TAG_ASSIGNED_CONSTANT = "input-tag-assigned";
export const INVITE_TEAM_MEMEBER_CONSTANT = "Invite Team Members";
export const TEAM_CONSTANT = "Team";
export const DISABLED_CONSTANT = "disabled";
export const FCCM_CONSTANT = "FCCM";
export const FCA_CONSTANT = "FCA";
export const FCA_HEADER_CONSTANT = "Fluke Connect™ Assets";
export const FCM_HEADER_CONSTANT = "Fluke Connect™ Measurements";
export const FCCM_HEADER_CONSTANT = "Fluke Connect™ Condition Monitoring";
export const ASSET_TRIAL_HEADER_CONSTANT = "Fluke Connect™ Assets - Free Trial";
export const READ_ONLY_CONSTANT = { YES: "Yes", NO: "No" };
export const USER_TYPE_OBJ_CONSTANT = {
  ADMINISTRATOR: ["Administrator", "66dd3a48-5185-11e3-9430-fbcf1b1a2e9a"],
  STANDARD_USER: ["Standard User", "B5C42396-BC53-11E2-9678-15B654818C3B"],
  INDIVIDUAL_USER: ["Individual User", "B5C423C8-BC53-11E2-9678-15B654818C3B"]
};
export const USER_TYPE_CONSTANT = {
  ADMINISTRATOR: {
    NAME: "Administrator",
    ROLE_ID: "66dd3a48-5185-11e3-9430-fbcf1b1a2e9a"
  },
  STANDARD_USER: {
    NAME: "Standard User",
    ROLE_ID: "B5C42396-BC53-11E2-9678-15B654818C3B"
  },
  INDIVIDUAL_USER: {
    NAME: "Individual User",
    ROLE_ID: "B5C423C8-BC53-11E2-9678-15B654818C3B"
  }
};
export const EDIT_TEAM_MEMBER_CONSTANT = "Edit Team Member";
export const CHECKED = "checked";
export const UI_CONSTANTS = {
  contentCollapsedHeight: "auto",
  contentExpandedHeight: "auto",
  moreLessSymbolPadding: "16px 0px 16px 0px",
  tabCollapsedHeight: "100vh",
  tabExpandedHeight: "100vh",
  expandedListMaxHeight: "auto",
  collapsedListMaxHeight: "auto"
};

export const FCM_OBJ_CONSTANT = {
  productHeader: "Fluke Connect™ Measurements",
  productName: "Fluke Connect™ Measurements",
  productId: "358603F4-DC47-4C76-AC30-42B3EFA883CB",
  isChecked: false,
  isErrorMsg: false,
  productAvailableLicense: -1,
  productTotalLicense: -1,
  showError: false
};
export const FCA_FREE_OBJ_CONSTANT = {
  productHeader: "Fluke Connect™ Assets - Free Trial",
  productName: "Fluke Connect™ Assets - Free Trial",
  productId: "04A8D2E4-48A5-48B4-9213-4B48BF185179",
  isChecked: false,
  isErrorMsg: false,
  productAvailableLicense: -1,
  productTotalLicense: -1,
  showError: false
};
export const FCA_Free_30DAYS_OBJ_CONSTANT = {
  productHeader: "Fluke Connect™ Assets Free Trial",
  productName: "Fluke Connect™ Assets Free Trial (30 days)",
  productId: "4E9D5F64-8997-4E12-BCAA-69FBB4294C71",
  isChecked: false,
  isErrorMsg: false,
  productAvailableLicense: -1,
  productTotalLicense: -1,
  showError: false
};

export const BACKGROUND_COLOR_5582 = "#5582BA";

export const COACHMARKS_DATA = {
  ADMIN_VIEW_COACHMARKS: [
    {
      headerName: i18next.t("welcome_to_new_team_page"),
      icon: adminWelcomeCoachmark,
      description: ""
    },
    {
      headerName: i18next.t("pending_invites"),
      icon: adminViewCoachmarks1,
      description: i18next.t("coachmark_pending_invite_message")
    },
    {
      headerName: i18next.t("team_list"),
      icon: adminViewCoachmarks2,
      description: i18next.t("coachmark_team_list_message")
    },
    {
      headerName: i18next.t("admin_indicator"),
      icon: adminViewCoachmarks3,
      description: i18next.t("coachmark_admin_indicator_message")
    },
    {
      headerName: i18next.t("leave_team"),
      icon: adminViewCoachmarks4,
      description: i18next.t("coachmark_leave_team_message")
    },
    {
      headerName: i18next.t("edit_remove_member"),
      icon: adminViewCoachmarks5,
      description: i18next.t("coachmark_edit_remove_member_message")
    }
  ],
  ADMIN_VIEW_LICENSE_COACHMARKS: [
    {
      headerName: i18next.t("license_tags"),
      icon: adminViewCoachmarks6,
      description: i18next.t("coachmark_license_tags_message")
    },
    {
      headerName: i18next.t("License"),
      icon: adminViewCoachmarks7,
      description: i18next.t("coachmark_license_summary_message")
    },
    {
      headerName: i18next.t("expired_licenses"),
      icon: adminViewCoachmarks8,
      description: i18next.t("coachmark_expired_license_message")
    }
  ],
  ADMIN_REQUESTS_COACHMARKS: [
    {
      headerName: i18next.t("pending_request"),
      icon: adminPendingRequests,
      description: i18next.t("pending_request_coachmark_message")
    },
    {
      headerName: i18next.t("available_indicator"),
      icon: adminAvailableIndicator,
      description: i18next.t("request_license_onboarding_2_msg")
    },
    {
      headerName: i18next.t("unavailable_indicator"),
      icon: adminUnavailableIndicator,
      description: i18next.t("request_license_onboarding_3_msg")
    },
    {
      headerName: i18next.t("approve_reject_request"),
      icon: adminApproveReject,
      description: i18next.t("request_license_onboarding_4_msg")
    }
  ],
  TEAM_MEMBER_COACHMARK: [{
    headerName: i18next.t("team_members"),
    icon: teamMembers,
    description: i18next.t("send_request_license_display_message")
  },
  {
    headerName: i18next.t("leave_team"),
    icon: teamLeaveTeam,
    description: i18next.t("coachmark_leave_team_message")
  }],
  TEAM_REQUEST_LICENSES_COACHMARKS: [
    {
      headerName: i18next.t("request_license"),
      icon: teamRequestLicense,
      description: i18next.t("send_request_license_message")
    },
    {
      headerName: i18next.t("request_status"),
      icon: teamRequestStatus,
      description: i18next.t("standard_user_onboarding_6_msg")
    },
    {
      headerName: i18next.t("reject_reason"),
      icon: teamRejectReason,
      description: i18next.t("standard_user_onboarding_7_msg")
    }
  ],
  ADMIN_LICENSE_REQUESTS_OPTION: {
    headerName: i18next.t("License Requests"),
    icon: adminLicenseRequests,
    description: i18next.t("admin_onboarding_5_msg")
  },
  TEAM_VIEW_COACHMARKS: [
    {
      headerName: i18next.t("welcome_to_new_team_page"),
      icon: teamViewCoachmarks1,
      description: ""
    },
    {
      headerName: i18next.t("my_team"),
      icon: teamViewCoachmarks3,
      description: i18next.t("coachmark_my_team_message")
    }
  ],
  TEAM_VIEW_LICENSE_COACHMARK: {
    headerName: i18next.t("Licenses"),
    icon: teamViewCoachmarks2,
    description: i18next.t("coachmark_team_license_message")
  },
  INVITE_TEAM_COACHMARKS: [
    {
      headerName: i18next.t("include_licenses"),
      icon: inviteTeamCoachmarks1,
      description: (
        i18next.t("coachmark_invite_team_include_license_message")
      )
    }
  ],
  MANAGE_LICENSES_COACHMARKS: [
    {
      headerName: i18next.t("manage_licenses"),
      icon: manageLicenses,
      description: i18next.t("manage_licenses_message")
    },
    {
      headerName: i18next.t("sensor_tool_info"),
      icon: sensorToolInfo,
      description: i18next.t("sensor_tool_info_message")
    },
    {
      headerName: i18next.t("active_expired_licenses"),
      icon: activeExpiredLicenses,
      description: i18next.t("active_expired_licenses_messages")
    },
    {
      headerName: i18next.t("renew_licenses"),
      icon: renewLicenses,
      description: i18next.t("renew_licenses_message")
    },
    {
      headerName: i18next.t("assigned_members2"),
      icon: assignedMembers,
      description: i18next.t("assigned_members_message")
    }
  ]
};

export const PREVIOUS_COACHMARK = i18next.t("Previous");

export const NEXT_COACHMARK = i18next.t("Next");

export const EMPTY_DASHBOARD_STRING_1 = (
  i18next.t("empty_dashboard_main_msg")
);

export const EMPTY_DASHBOARD_STRING_2 = (
  i18next.t("empty_dashboard_side_msg")
);

export const EMPTY_DASHBOARD_STRING_3 = i18next.t("buy_licenses");

export const INACTIVE_OBJECT_STATUS_ID = "5BBB9C8E-BC4F-11E2-9678-15B654818C3B";

export const ADMIN_VIEW_COACHMARKS = "ADMIN_VIEW_COACHMARKS";
export const TEAM_VIEW_COACHMARKS = "TEAM_VIEW_COACHMARKS";
export const INVITE_USER_COACHMARKS = "INVITE_USER_COACHMARKS";

export const ADMIN_LICENSE_REQUESTS_COACHMARKS =
  "ADMIN_LICENSE_REQUESTS_COACHMARKS";
export const TEAM_REQUEST_LICENSES_COACHMARKS =
  "TEAM_REQUEST_LICENSES_COACHMARKS";

export const ADMIN_MANAGE_LICENSES_COACHMARKS =
  "ADMIN_MANAGE_LICENSES_COACHMARKS";

export const KEYUP_CONSTANT = "keyup";
export const BLUR_CONSTANT = "blur";
export const REQUEST = "REQUEST";
export const SUBSCRIPTION_REQUESTS = i18next.t("subscription_request");
export const LICENSE_REQUESTS = "License Requests";
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";
export const APPROVE_REQUEST = "Approve Request";
export const REJECT_REQUEST = "Reject Request";
export const COMMENTS = "Comments *";
export const ENTER_COMMENTS = "Enter comments...";
export const REJECT_REQUEST_STR1 = "Please confirm to reject the request of ";
export const REJECT_REQUEST_STR2 = " for ";
export const REJECT_REQUEST_STR3 = " license.";
export const CONFIRM = "CONFIRM";
export const AVAILABLE = "Available";
export const APPROVE = i18next.t("Approve");
export const REJECT_LOWERCASE = i18next.t("Reject");
export const MORE = "More...";
export const EMPTY_SUBSCRIPTION_REQUESTS = "No Subscription Requests Available";
export const ACCEPT_REQUEST_STR1 = "Please confirm to accept the request of ";
export const ACCEPT_REQUEST_STR2 = " for ";
export const ACCEPT_REQUEST_STR3 = " license.";
export const SUBSCRIPTION_REQUEST_CONSTANT = "Subscription Request";
export const SELECTED_FCCM_STATUS = "Fluke Connect™ Condition Monitoring";
export const EMPTY_REQUESTS_BODY1 = (
  i18next.t("empty_request_subscription_header")
);
export const EMPTY_REQUESTS_BODY2 = (
  i18next.t("empty_request_subscription_body")
);
export const SUBSCRIPTION_REQUEST_KEY = "subscriptionRequest";
export const PRODUCT_LICENSES_KEY = "productLicenses";
export const MANAGE_LICENSES_KEY = "manageLicenses";
export const CONDITION_MONITOR_PRODUCT_NAMES = [
  "Condition Monitoring",
  "Electrical",
  "Power Monitor",
  "Power Logger",
  "Thermal",
  "Vibration"
];
export const ASSETS_PRODUCT_NAME = "Assets";
export const MOVE_FC_FREE_MSG = "move_fc_free_msg";
export const YOU = "You";
export const EXCLUSIVE_SUBSCRIPTION_TOGGLE = "Exclusive subscription";
export const EMPTY_ASSIGNED_MEMBERS_BODY1 = (
  i18next.t("empty_assigned_members_header")
);
export const EMPTY_ASSIGNED_MEMBERS_BODY2 = (
  i18next.t("empty_assigned_members_body")
);

export const ASSIGN_CONSTANT = "assign";
export const INITIATE_CSM_RENEW_REQUEST = "INITIATE_CSM_RENEW_REQUEST";
export const INITIATE_CSM_PURCHASE_REQUEST = "INITIATE_CSM_PURCHASE_REQUEST";

export const EMPTY_EXPIRED_LICENSES_BODY1 =
  "You don’t have any expired licenses";
export const EMPTY_EXPIRED_LICENSES_BODY2 =
  "Licenses which are expired will be displayed here";

export const FCCM_PRODUCT_IDS = [
  "185ca536-80e5-477f-af64-4a8da05074f7",
  "20ed36da-fc0e-4a66-9fd2-c84870f0ff58",
  "355773a7-edcf-4887-a79e-731c0e179ad1",
  "4381d1b6-13cf-4bc7-88d5-b775cefd127c",
  "99341615-91e6-4e15-826a-7a7047a7fa82",
  "9a0a6b89-8fb1-4351-b633-c4f703fc2e56",
  "d5ba3c32-aade-4d9b-b066-35b1692ce4fa"
];
export const COACHMARK_SELECTED_CLASS = "coachmarkSelected";
export const FIVE_THOUSAND_MILISECONDS = 5000;
